<template>
	<div class="global-footer-copyright">
		<!-- eslint-disable -->
		<p>
			© 2005 - {{ currentYear }} WebMD LLC, an <a href="https://www.internetbrands.com/" target="_blank" rel="nofollow">Internet Brands</a> company.
			All rights reserved. WebMD does not provide medical advice, diagnosis or treatment.
			<a href="https://www.webmd.com/about-webmd-policies/additional-info">See additional information.</a>
		</p>
		<!-- eslint-enable -->
	</div>
</template>
<script>
export default {
	name: 'FooterCopyRight',
	props: {
		currentYear: {
			type: Number,
			required: true,
		},
	},
};
</script>
